import { createApi } from "@reduxjs/toolkit/query/react";
import { AdditionalDataRequirementResponse } from "@/types/userAccount";
import { customBaseQuery } from "./customBaseQuery";

export const userAccountApi = createApi({
  reducerPath: "userAccountApi",
  baseQuery: customBaseQuery,
  tagTypes: ["AdditionalDataRequirement"],
  endpoints: (builder) => ({
    checkAdditionalDataRequirement: builder.query<
      AdditionalDataRequirementResponse,
      void
    >({
      query: () => ({ url: "/UserAccount/CheckAdditionalDataRequirement" }),
      providesTags: ["AdditionalDataRequirement"],
    }),
  }),
});

export const { useCheckAdditionalDataRequirementQuery } = userAccountApi;
